// assets/collection-load-more.js

const initCollectionLoadMore = () => {
  // Only activate on pages that actually have this feature
  if (document.querySelector('.collection-load-more')) {

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('.collection-load-more');
    if (!button) return;

    event.preventDefault();
    if (button.disabled) return;

    const nextUrl = button.dataset.nextUrl;
    const sectionId = button.dataset.sectionId;
    if (!nextUrl || !sectionId) return;

    const resultsList = button.closest(`results-list[section-id="${sectionId}"]`);
    if (!resultsList) return;

    const grid = resultsList.querySelector('[data-testid="product-grid"]');
    if (!grid) return;

    button.disabled = true;
    button.classList.add('is-loading');

    try {
      const url = new URL(nextUrl, window.location.origin);
      url.searchParams.set('section_id', sectionId);

      const response = await fetch(url.toString(), {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });

      if (!response.ok) throw new Error('Failed to load more products');

      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const newResultsList = doc.querySelector(`results-list[section-id="${sectionId}"]`);
      const newGrid = newResultsList?.querySelector('[data-testid="product-grid"]');
      const newButton = newResultsList?.querySelector('.collection-load-more');

      if (newGrid) {
        const newItems = Array.from(newGrid.children);
        newItems.forEach((item) => grid.appendChild(item));
        if (window.KiehlsPincodeEdd && typeof window.KiehlsPincodeEdd.refreshCards === 'function') {
          window.KiehlsPincodeEdd.refreshCards();
        }
      }

      if (newButton && newButton.dataset.nextUrl) {
        button.dataset.nextUrl = newButton.dataset.nextUrl;
        button.disabled = false;
        button.classList.remove('is-loading');
      } else {
        button.closest('.collection-load-more__wrapper')?.remove();
      }

      if (typeof ReloadSmartWishlist === 'function') {
        try {
          ReloadSmartWishlist();
        } catch (err) {
          console.warn('SmartWishlist reload failed:', err);
        }
      }
    } catch (error) {
      console.error(error);
      button.disabled = false;
      button.classList.remove('is-loading');
    }
  });

}
};

document.addEventListener('DOMContentLoaded', initCollectionLoadMore);